window.VIULET_ASSETS = {
  "schemaVersion": 1,
  "atlasSize": 1152,
  "sliceBorder": 192,
  "frameFaceInches": 0.75,
  "frames": {
    "Seraph White": {
      "path": window.ViuletJourneyAsset("assets/frame-atlas-seraph-white.webp"),
      "sha256": "4625e008e99fffac60a5e0a32b1048947e7c251bfa4b2e173c8cf35763cef2b8",
      "bytes": 484104,
      "width": 1152,
      "height": 1152,
      "hasAlpha": true,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/frame-atlas-seraph-white.webp"),
      "sliceBorder": 192,
      "border": 192,
      "faceInches": 0.75,
      "centerTransparent": true
    },
    "Nocturne Black": {
      "path": window.ViuletJourneyAsset("assets/frame-atlas-nocturne-black.webp"),
      "sha256": "55987c6e3307e3dbf0e4b2cbdff2dce186bd55ea0f1fb140f07b759abf3a792c",
      "bytes": 567258,
      "width": 1152,
      "height": 1152,
      "hasAlpha": true,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/frame-atlas-nocturne-black.webp"),
      "sliceBorder": 192,
      "border": 192,
      "faceInches": 0.75,
      "centerTransparent": true
    },
    "Atelier Wood": {
      "path": window.ViuletJourneyAsset("assets/frame-atlas-atelier-wood.webp"),
      "sha256": "493fa38e6d04f208fac1679163361d90868a0aef5f0b97e97d3aff1b5a4545cd",
      "bytes": 760574,
      "width": 1152,
      "height": 1152,
      "hasAlpha": true,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/frame-atlas-atelier-wood.webp"),
      "sliceBorder": 192,
      "border": 192,
      "faceInches": 0.75,
      "centerTransparent": true
    },
    "Midas Gold": {
      "path": window.ViuletJourneyAsset("assets/frame-atlas-midas-gold.webp"),
      "sha256": "e573eef3844fece0ce6d87859fc532c9a6276f2aa27c164523887b8e12510a22",
      "bytes": 795352,
      "width": 1152,
      "height": 1152,
      "hasAlpha": true,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/frame-atlas-midas-gold.webp"),
      "sliceBorder": 192,
      "border": 192,
      "faceInches": 0.75,
      "centerTransparent": true
    },
    "Midnight Silver": {
      "path": window.ViuletJourneyAsset("assets/frame-atlas-midnight-silver.webp"),
      "sha256": "a23c8e75a49242ea26883d445b4a2b12d62d4ff55d3f7c992c1609101ebe9f1e",
      "bytes": 764020,
      "width": 1152,
      "height": 1152,
      "hasAlpha": true,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/frame-atlas-midnight-silver.webp"),
      "sliceBorder": 192,
      "border": 192,
      "faceInches": 0.75,
      "centerTransparent": true
    }
  },
  "mats": {
    "White": {
      "path": window.ViuletJourneyAsset("assets/mat-white.png"),
      "sha256": "cdd128fd610bdd74be04d8333558982195b29003a2f72fc5009c29787666ecac",
      "bytes": 1320,
      "width": 256,
      "height": 64,
      "hasAlpha": false,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/mat-white.png"),
      "patternWidthInches": 4.25,
      "patternHeightInches": 1.0625
    },
    "Cream": {
      "path": window.ViuletJourneyAsset("assets/mat-cream.png"),
      "sha256": "fa33208b078508afa777086a98324b9b0a848c0b5335d40be8708664355ff985",
      "bytes": 1471,
      "width": 256,
      "height": 64,
      "hasAlpha": false,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/mat-cream.png"),
      "patternWidthInches": 4.25,
      "patternHeightInches": 1.0625
    },
    "Black": {
      "path": window.ViuletJourneyAsset("assets/mat-black.png"),
      "sha256": "efa35090e701f8a9c8516b6e831f94ffe6e6b39f4944131fe52cbb830614e612",
      "bytes": 21023,
      "width": 256,
      "height": 64,
      "hasAlpha": false,
      "iccSha256": null,
      "src": window.ViuletJourneyAsset("assets/mat-black.png"),
      "patternWidthInches": 4.25,
      "patternHeightInches": 1.0625
    }
  },
  "details": {
    "Seraph White": {
      "path": window.ViuletJourneyAsset("assets/frame-detail-seraph-white.png"),
      "sha256": "c4e5efa4679199fde3be20ac09a387f17bcd20c97804b2e35a3012db66018b11",
      "bytes": 308829,
      "width": 800,
      "height": 800,
      "hasAlpha": true,
      "iccSha256": null
    },
    "Nocturne Black": {
      "path": window.ViuletJourneyAsset("assets/frame-detail-nocturne-black.png"),
      "sha256": "38f6d5b6c4c14706e1c234521ca61a333496fea7576f7fce1550b8fd39b05dcc",
      "bytes": 516344,
      "width": 800,
      "height": 800,
      "hasAlpha": true,
      "iccSha256": null
    },
    "Atelier Wood": {
      "path": window.ViuletJourneyAsset("assets/frame-detail-atelier-wood.png"),
      "sha256": "27e0c9d4066e323e42a4bd2b4bc15e661ffca5243dfcaea65f61adffc6611cd2",
      "bytes": 596245,
      "width": 800,
      "height": 800,
      "hasAlpha": true,
      "iccSha256": null
    },
    "Midas Gold": {
      "path": window.ViuletJourneyAsset("assets/frame-detail-midas-gold.png"),
      "sha256": "862b66946375f83b0d50391c259afc48810696cd3c96de754929abdb4b2af74b",
      "bytes": 622216,
      "width": 800,
      "height": 800,
      "hasAlpha": true,
      "iccSha256": null
    },
    "Midnight Silver": {
      "path": window.ViuletJourneyAsset("assets/frame-detail-midnight-silver.png"),
      "sha256": "828d4ca76a8afcc92a52a90996d1911c9714afeb67da22b6d360f77e3d7b3427",
      "bytes": 569239,
      "width": 800,
      "height": 800,
      "hasAlpha": true,
      "iccSha256": null
    }
  },
  "artwork": {
    "display": {
      "path": window.ViuletJourneyAsset("assets/artwork-letters-print-color-srgb-4096.webp"),
      "sha256": "d5e18167ce27bed168b8905a0bc062f1e494150b2654787a80c91f51d9383399",
      "bytes": 7004792,
      "width": 4096,
      "height": 4096,
      "hasAlpha": false,
      "iccSha256": "c56e1685d888f5edb92fe07f2750f387f8fe8e91b32ff8fb0b56bfbbb9458353"
    },
    "detail": {
      "path": window.ViuletJourneyAsset("assets/artwork-letters-print-color-srgb-6000.webp"),
      "sha256": "7b892b0dfa626c7ac7fd346a8aaa8bdbe18fb7a67f7eb5241b16851e1b5b9d5e",
      "bytes": 15847372,
      "width": 6000,
      "height": 6000,
      "hasAlpha": false,
      "iccSha256": "c56e1685d888f5edb92fe07f2750f387f8fe8e91b32ff8fb0b56bfbbb9458353"
    },
    "preview": {
      "path": window.ViuletJourneyAsset("assets/artwork-letters-print-color-preview.jpg"),
      "sha256": "72208c7d6cacb61be1423fcb5d7b1de5a220227347a4668179ca3479f9575ab1",
      "bytes": 715624,
      "width": 1024,
      "height": 1024,
      "hasAlpha": false,
      "iccSha256": "c56e1685d888f5edb92fe07f2750f387f8fe8e91b32ff8fb0b56bfbbb9458353"
    },
    "width": 10000,
    "height": 10000,
    "colorSpace": "sRGB",
    "colorManaged": true
  }
};